import 'bootstrap';
import 'select2';
import "./vendor/featherlight.js";
//import "./vendor/sortable.js";

require('datatables.net')(window, $);
require('datatables.net-bs5')(window, $);  // if you added this plugin
require('datatables.net-buttons')(window, $);  // if you added this plugin
require('datatables.net-buttons-bs5')(window, $);  // if you added this plugin

window.bootstrap = require('bootstrap');

$(document).ready(function () {
    let $body = $("body");
    let ajaxTarget = $body.attr("data-ajaxurl");

    let enableTooltips = () => {
        var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
        var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new bootstrap.Tooltip(tooltipTriggerEl)
        })
    }
    enableTooltips();

    let enableSelect2 = () => {
        $("select.select2").each(function () {
            let $select = $(this);

            if ($select.is("[data-select2-active]")) {
                return;
            }

            $select.select2({
                placeholder: "Auswählen...",
                templateResult: function (option) {
                    if (option.element && (option.element).hasAttribute('hidden')) {
                        return null;
                    }
                    return option.text;
                }
            });
        })
    }
    enableSelect2();

    let debounce = (functionToDebounce, wait, immediate, context) => {
        var timeout;
        return function () {
            context = context ? context : this;
            var args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) {
                    functionToDebounce.apply(context, args);
                }
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) {
                functionToDebounce.apply(context, args);
            }
        };
    }

    let addAjaxParams = (data) => {
        let csrfName = $body.attr("data-csrfname");
        let csrfValue = $body.attr("data-csrfvalue");

        data.dblwreg = true
        data[csrfName] = csrfValue;

        return data;
    }

    let postViaAjax = (data) => {
        return $.ajax({
            url: ajaxTarget,
            type: 'post',
            data: addAjaxParams(data)
        })
    }

    let objectifyForm = (formArray) => {
        //serialize data function
        var returnArray = {};
        for (var i = 0; i < formArray.length; i++) {
            returnArray[formArray[i]['name']] = formArray[i]['value'];
        }
        return returnArray;
    }

    let triggerDesync = (result) => {
        if (result.error && result.error === "desynchronized") {
            let url = new URL(window.location.href);
            url.searchParams.append('desync', "1");
            window.location.href = url.href;
        }
    }

    let handleDesync = () => {
        let url = new URL(window.location.href);
        let desync = url.searchParams.get("desync");

        if (desync && desync === "1") {
            alert("Die aktuelle Seite wurde neu geladen, da Ihre Ansicht nicht mehr mit der Datenbank synchron war. Sie können jetzt wie gewohnt weiterarbeiten.");
            window.history.replaceState(null, null, window.location.pathname);
        }
    }
    handleDesync();

    let pages = {
        managementTable: function () {
            let resetHelpFunctions = () => {
                $(".tooltip").remove();
                enableTooltips();
                enableSelect2();
            }

            console.log("[LWREG] Running table scripts");
            let $table = $(".lwreg-management__table");
            let $statusSelector = $(".status-selector");

            $(".lwreg-datatable").show().dataTable({
                "oLanguage": {
                    "sSearch": "Suche:",
                    "sZeroRecords": "Keine passenden Einträge gefunden",
                    "sInfoFiltered": " - aus _MAX_ Einträgen gefiltert",
                    "sInfo": "_START_ bis _END_ von _TOTAL_ Einträgen",
                    "sLengthMenu": "_MENU_ Zeilen anzeigen",
                    "oPaginate": {
                        "sPrevious": "Vorherige",
                        "sNext": "Nächste",
                    }
                }
            });


            $(window).on('lwreg.listUpdated', () => {
                updateCount();
            });

            /**
             * Change networks via inline select2
             */
            $table.on("change", ".network-select", function (e) {
                let $select = $(this);
                let values = $select.val();
                let $row = $select.closest("[data-request]");

                let data = {
                    action: "update_networks",
                    requestId: $row.attr("data-request"),
                    networks: values,
                };

                postViaAjax(data).then(function (result) {
                    console.log(result)

                    triggerDesync(result);

                    if (result.success) {
                        if (result.networksString) {
                            $row.find("[data-type=networks]").attr("data-search", result.networksString)

                            let dt = $table.DataTable();
                            dt.row($row).invalidate();
                        }

                        $row.find(".reg-action").toggleClass("d-none", !(result.networkCount > 0));
                        // Nice!
                    }
                })
            })

            /**
             * Change regions via inline select2
             */
            $table.on("change", ".region-select", function (e) {
                let $select = $(this);
                let regionsFromForm = $select.val();
                let $row = $select.closest("[data-request]");

                let data = {
                    action: "update_regions",
                    requestId: $row.attr("data-request"),
                    regions: regionsFromForm,
                };

                postViaAjax(data).then(function (result) {
                    console.log(result)

                    triggerDesync(result);

                    if (result.success) {
                        console.log(regionsFromForm);

                        if (result.regionsString) {
                            $row.find("[data-type=regions]").attr("data-search", result.regionsString)

                            let dt = $table.DataTable();
                            dt.row($row).invalidate();
                        }

                        let $networkSelect = $row.find(".network-select");

                        let activeoptions = [];

                        $networkSelect.find("option").each(function () {
                            let $option = $(this);

                            if (regionsFromForm.includes($option.attr("data-region"))) {
                                $option.removeAttr("hidden")

                                if ($option.is(":selected")) {
                                    activeoptions.push($option.val());
                                }

                                console.log($option.text().trim() + " not removed");
                            } else {
                                $option
                                    .attr("hidden", "hidden")
                                    .removeAttr("selected");
                            }
                        })

                        $networkSelect.val(activeoptions);

                        $networkSelect.trigger("change");

                        $row.find(".reg-action").toggleClass("d-none", !($networkSelect.find("option:selected").length > 0));
                        // Nice!
                    }
                })
            })

            /**
             * Add to export list
             */
            let $addToExportButton = $("#lwreg-add-to-export");
            $addToExportButton.on("click", function (e) {
                console.log("Starting export");

                let $checkboxes = $table.find(".lwreg-check-request").filter(":checked").filter(":visible");

                let ids = [];
                $checkboxes.each(function () {
                    ids.push($(this).val());
                })

                if (!ids.length) {
                    return;
                }

                let data = {
                    action: "add_to_export",
                    requestIds: ids,
                };

                postViaAjax(data).then(function (result) {
                    console.log(result)

                    triggerDesync(result);

                    if (result.success) {
                        window.location = window.location.href;
                    }
                })

            })

            /**
             * Select/Deselect all checkboxes
             */
            $table.on("change", ".lwreg-check-request--all", function (e) {
                console.log("Changing status for checkboxes");

                let $thisCheckbox = $(this);
                let $checkboxes = $table.find(".lwreg-check-request").filter(":visible");

                $checkboxes.each(function () {
                    if ($thisCheckbox.is(":checked")) {
                        $(this).attr("checked", 1);
                    } else {
                        $(this).removeAttr("checked");
                    }
                })
            })

            /**
             * Update status count
             */
            let updateCount = () => {
                if (!$statusSelector.length) {
                    return;
                }

                let activeStatus = $statusSelector.find("input[type=radio]:checked").val();

                let dt = $table.DataTable();

                let count = {
                    all: dt.rows().count()
                }

                $.fn.dataTable.ext.search.pop();
                $.fn.dataTable.ext.search.push(
                    function (settings, data, dataIndex) {
                        let found = false;

                        $.each(data, (index, column) => {
                            if (column.indexOf("status|") > -1) {
                                let currentStatus = column.split("|")[1];

                                if (!count[currentStatus]) {
                                    count[currentStatus] = 0;
                                }
                                count[currentStatus]++;

                                if (currentStatus === activeStatus) {
                                    found = true;
                                }
                            }
                        });

                        if (activeStatus === "all") {
                            return true;
                        }

                        return found;
                    }
                );
                dt.draw(false);

                $statusSelector.find("label").each(function () {
                    if (count[$(this).attr("for")]) {
                        $(this).find(".count").text(count[$(this).attr("for")])
                    } else {
                        $(this).find(".count").text(0)
                    }
                })

                resetHelpFunctions();
            }

            /**
             * Handle status selector
             */
            if ($statusSelector.length) {
                $statusSelector.on("click change", "input[type=radio]", function () {
                    let dt = $table.DataTable();
                    dt.draw();

                    $(window).trigger("lwreg.listUpdated");
                })
                $statusSelector.find("input[checked]").first().trigger("click").trigger("change");
            }


            /**
             * Handle clicks on actions buttons
             */
            $table.on("click", ".reg-action, .acy-action", function (e) {
                e.preventDefault();

                let $button = $(this);
                let action = $button.attr("data-action")
                $button.attr("disabled", "disabled")

                let $row = $button.closest("[data-request], [data-agency]");

                let data = {};

                switch (action) {
                    case "move_request_forward":
                        data.action = action;
                        data.currentStatus = $row.find("[data-status]").attr("data-status");
                        data.requestId = $row.attr("data-request");
                        break;
                    case "move_request_backward":
                        data.action = action;
                        data.currentStatus = $row.find("[data-status]").attr("data-status");
                        data.requestId = $row.attr("data-request");
                        break;
                    case "change_agency_status":
                        data.action = action;
                        data.agencyId = $row.attr("data-agency");
                        break;
                }

                if (data.action) {
                    postViaAjax(data).then(function (result) {
                        let dt = $table.DataTable();

                        console.log(result);

                        triggerDesync(result);

                        if (result.success && result.html.length) {
                            if ($table.is("[data-delete-after]")) {
                                console.log("Row deleted!");
                            } else {
                                console.log("Row added!");
                                dt.row.add($(result.html));
                            }

                            $row.remove();
                            dt.row($row).remove();
                            dt.draw(false);
                        }

                        $button.removeAttr("disabled");

                        resetHelpFunctions();
                        $(window).trigger('lwreg.listUpdated');
                    })
                }
            })
        }
    }

    if ($(".lwreg-management__table").length) {
        pages.managementTable();
    }
});